import { render, staticRenderFns } from "./GlobalIntegrationReport.vue?vue&type=template&id=d841e2e4&"
import script from "./GlobalIntegrationReport.vue?vue&type=script&lang=js&"
export * from "./GlobalIntegrationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports